import React, { FC, ReactNode, useMemo, useState } from 'react';
import PageLoaded from '../PageLoadedContext';

export interface PageLoadedProviderProps {
  children: ReactNode;
}

const PageLoadedProvider: FC<PageLoadedProviderProps> = ({ children }) => {
  const [pagesLoaded, setPagesLoaded] = useState([]);
  const context = useMemo(() => ({
    pagesLoaded,
    setPageLoaded: (page: string) => setPagesLoaded((x) => [...x, page]),
  }), [pagesLoaded]);

  return (
    <PageLoaded.Provider value={context}>
      {children}
    </PageLoaded.Provider>
  );
};

export default PageLoadedProvider;
